import {
  FETCH_NORMALORDERS_SUCCESS_ACTION,
  FETCH_INPROGRESSORDERS_SUCCESS_ACTION,
  FETCH_DELIVEREDORDERS_SUCCESS_ACTION,
  FETCH_CANCELLEDORDERS_SUCCESS_ACTION,
  FETCH_NORMALORDERVIEW_SUCCESS_ACTION,
  GET_COMPLETEITEMS_SUCCESS_ACTION,
  FETCH_NORMALDLVRYSTATUS_SUCCESS_ACTION,
  SEARCH_NORMALORDERITEMS_SUCCESS_ACTION,
} from './action';

const initialState = {
  processing: false,
  error: false,
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_NORMALORDERS_SUCCESS_ACTION:
      return {
        ...state,
        newOrdersList: action.payload.rows,
        newOrdersListCount: action.payload.count,
      };

    case FETCH_INPROGRESSORDERS_SUCCESS_ACTION:
      return {
        ...state,
        processedOrdersList: action.payload.rows,
        processedOrdersListCount: action.payload.count,
      };

    case FETCH_DELIVEREDORDERS_SUCCESS_ACTION:
      return {
        ...state,
        deliveredOrdersList: action.payload.rows,
        deliveredOrdersListCount: action.payload.count,
      };

    case FETCH_CANCELLEDORDERS_SUCCESS_ACTION:
      return {
        ...state,
        cancelledOrdersList: action.payload.rows,
        cancelledOrdersListCount: action.payload.count,
      };

    case FETCH_NORMALORDERVIEW_SUCCESS_ACTION:
      // console.log(action.payload.rows);
      // console.log(action.payload.count);
      return {
        ...state,
        normalOrderDtls: action.payload.rows,
        normalOrderDtlsCount: action.payload.count,
      };

    case GET_COMPLETEITEMS_SUCCESS_ACTION:
      return {
        ...state,
        completeitemDetails: action.payload.rows,
        completeitemDetailsCount: action.payload.count,
      };
    case FETCH_NORMALDLVRYSTATUS_SUCCESS_ACTION:
      return {
        ...state,
        normaldlvrystatusList: action.payload.rows,
      };

    case SEARCH_NORMALORDERITEMS_SUCCESS_ACTION:
      return {
        ...state,
        normalOrderSearchList: action.payload.rows,
        normalOrderSearchCount: action.payload.count,
      };

    default:
      return {
        ...state,
      };
  }
}
